"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 0L0 20h20L10 0zM9 6l6 12H3L9 6z"];
//# sourceMappingURL=delta.js.map